import { render } from "./InfoAtendimento.vue?vue&type=template&id=7dfcfa1a"
import script from "./InfoAtendimento.vue?vue&type=script&lang=js"
export * from "./InfoAtendimento.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__